import * as React from 'react';
import axios from 'axios';
import { RefObject } from "react";
import { Bar } from "react-chartjs-2";

export type ChartAction = FetchChartDataAction | FetchedChartDataAction | FetchingChartDataAction;

export type ManageableChart = [ChartData, React.Dispatch<ChartAction>];

export type FetchChartDataAction = {
    type: 'FETCH';
    payload: {};
};

export type FetchingChartDataAction = {
    type: 'FETCHING';
    payload: {};
};

export type FetchedChartDataAction = {
    type: 'FETCHED';
    payload: {
        data: ChartData
    };
};

export type ChartData = {
    initialized: boolean;
    fetching: boolean;
    fetch: boolean;
    scan_id: string;
    title: string;
    description: string;
    count_complete: number;
    count_in_progress: number;
    count_total: number;
    result_set: Array<ResultSet>;
}

export type ResultSet = {
    title: string;
    count_complete: number;
    chapter: Array<Chapter>;
    result: Array<Result>;
    filter_id: string;
}

export type Result = {
    title: string;
    score: number;
    percent: number;
    abbr: string;
}

export type Chapter = {
    chapter_id: string;
    title: string;
    color: string;
    description: string;
    total: number;
    question: Array<Question>;
    result: Array<Result>;
}

export type Question = {
    question_id: string;
    title:string;
    total: number;
    answer: Array<Answer>;
}

export type Answer = {
    answer: string;
    title:string;
    score: number;
    abbr: string;
    percent: number;
}

export const ChartDataContext: React.Context<ManageableChart> = React.createContext<ManageableChart>([
    initialState(),
    (): void => undefined,
]);


type ChartProps = {
    children: React.ReactNode;
    ajaxUrl: string;
    scanId: string;
};


function chartDataReducer(data: ChartData, action: ChartAction): ChartData {
    switch (action.type) {
        case 'FETCH':
            return {
                ...data,
                fetch: true
            };
        case 'FETCHING':
            return {
                ...data,
                fetching: true
            };
        case 'FETCHED':
            return {
                ...action.payload.data,
                initialized: true,
                fetch: false,
                fetching: false
            };
        default:
            return data;
    }
}

function initialState(): ChartData {
    return {
        initialized: false,
        fetching: false,
        fetch: false,
        scan_id: '',
        title: '',
        description: '',
        count_complete: 0,
        count_in_progress: 0,
        count_total: 0,
        result_set: []
    };
}

export function ChartDataProvider(props: ChartProps): JSX.Element {
    const [data, dispatch] = React.useReducer(
        chartDataReducer,
        initialState(),
    );

    React.useEffect(() => {
        dispatch(
            {
                type: 'FETCH',
                payload: {},
            }
        );
    }, []);

    React.useEffect((): void => {
        if (!data.fetching) {

            if (data.fetch) {
                dispatch({type: 'FETCHING', payload: {}});

                axios
                    .get(
                        `${props.ajaxUrl}?action=zmpzt_persona_scan_get_stats&scan_id=${props.scanId}`
                    )
                    .then((res): void => {
                        if (!res.data) {
                            return;
                        }
                        dispatch({type: 'FETCHED', payload: {data: res.data}});
                    });

            }

        }
    }, [data]);

    return (
        <ChartDataContext.Provider value={[data, dispatch]}>
            {props.children}
        </ChartDataContext.Provider>
    );
}
